import { Box, Drawer, IconButton, Typography } from "@mui/material";
import { FiltersDrawerProps } from "../../interfaces/props/FiltersDrawerProps";
import CloseIcon from '@mui/icons-material/Close';
import Filters from "../../views/filters/Filters";

const FiltersDrawer = ({ isOpen, onClose }: FiltersDrawerProps) => {
  return <Drawer
    anchor={'bottom'}
    open={isOpen}
  >
    <Box className='vh-100'>
      <Box className='border p-4'>
        <Box className='d-flex flex-row align-items-center justify-content-between'>
          <Typography className='h3'>
            Filters
          </Typography>
          <IconButton onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </Box>
        <Typography className='text-base' color={'#597680'}>
          All changes will be applied automatically for Articles
        </Typography>
      </Box>
      <Filters/>
    </Box>
  </Drawer>
};

export default FiltersDrawer;
